import { openLeaveFeedbackModal } from '@components/App/Modal/LeaveFeedback'
import { FlagLight } from '@octopus-do/octopus-storybook/icons'
import type React from 'react'
import { useDispatch } from 'react-redux'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { useAuth } from '@/hooks'
import css from './styles.module.css'

export const ExportRequest: React.FC = () => {
  const dispatch = useDispatch()
  const { authenticated } = useAuth()

  if (!authenticated) {
    return null
  }

  const handleOnClick = () => {
    sendGtmEvent(GtmTriggerName.EXPORT_REQUEST)
    dispatch(openLeaveFeedbackModal('export'))
  }

  return (
    <button type="button" className={css.request} onClick={handleOnClick}>
      <div className={css.icon_wrap}>
        <FlagLight className={css.icon} />
      </div>

      <div className={css.label}>Request</div>
    </button>
  )
}
